import { createRoot } from "react-dom/client";
import PrintInvoice from "./PrintInvoice";

const handlePrintInvoice = (data) => {
  const printWindow = window.open("", "_blank", "width=800,height=600");

  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>Invoice Print</title>
          <style>
            body { margin: 20px; font-family: 'Segoe UI', sans-serif; }
            @media print {
              body { margin: 0; }
              .print-page { page-break-after: always; }
            }
          </style>
        </head>
        <body>
          <div id="print-root"></div>
        </body>
      </html>
    `);

    printWindow.document.close();

    const interval = setInterval(() => {
      const rootDiv = printWindow.document.getElementById("print-root");
      if (rootDiv) {
        clearInterval(interval);
        const root = createRoot(rootDiv);
        root.render(<PrintInvoice data={data} printWindow={printWindow} />);
      }
    }, 100);
  }
};

export default handlePrintInvoice;